import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';

@Component({
    templateUrl: './result-analysis-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ResultAnalysisDialogComponent {
    @Input() public type: 'kpi-result' | 'data-entry-response';

    @Input() public resultAnalysisAr: string;
    @Input() public resultAnalysisEn: string;

    // Fields Only For Kpi Result
    @Input() public isApproved = true;
    @Input() public allowDynamicAnalysisEdit = false;

    // Fields Only For Data Entry Response
    @Input() public canEditResultAnalysis = false;
    @Input() public readOnly: boolean = false;

    @Output() public itemUpdated: EventEmitter<{ ar: string; en: string }> =
        new EventEmitter<{ ar: string; en: string }>();

    public submit(): void {
        this.itemUpdated.emit({
            ar: this.resultAnalysisAr,
            en: this.resultAnalysisEn,
        });
    }
}
